import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../actionTypes';

const initialState = false;

const isLoading = () => true;
const isEnding = () => false;

export default createReducer(initialState, {
  [actionTypes.FETCH_LOCKER_TASKS]: isLoading,
  [actionTypes.FETCH_LOCKER_TASKS_SUCCESS]: isEnding,
  [actionTypes.FETCH_LOCKER_TASKS_FAILURE]: isEnding,
});
